<mat-card *ngIf="selectedOutput$ | async as output">
  <div class="selected-section selected-section__title app-title" [ngClass]="{'dark-theme': isDarkTheme$ | async}">{{output.name}} (Door)
  </div>
  <div class="selected-section selected-section__data" [ngClass]="{'dark-theme': isDarkTheme$ | async}">
    <div><span>item name: </span><span class="bold-text">{{output.name}}</span></div>
    <div><span>item type: </span><span class="bold-text">{{output.type}}</span></div>
  </div>
  <div class="selected-section selected-section__output-status" [ngClass]="{'dark-theme': isDarkTheme$ | async}">
    <div class="app-title">Status</div>
    <div>
      <div>Opening state:</div>
      <div class="toggle-button">
        <label [ngClass]="{'clicked': output.status === outputOpeningStatus.Closed}">
          Closed</label>
        <label [ngClass]="{'clicked': output.status === outputOpeningStatus.Open}">
          Opened</label>
      </div>
    </div>
    <div class="width-two-thirds">
      <div>Lock state:</div>
      <app-lock-actions [isLocking]="output.isLocking" [isUnlocking]="output.isUnlocking" [itemStatus]="output.status"
                        (onLockClick)="closeOutput(output)" (onUnlockClick)="openOutput(output)"></app-lock-actions>
    </div>
  </div>
</mat-card>
